<template>
    <div>
        <v-dialog v-model="createCampaignDialog" content-class="create-campaign-con" :overlay-opacity="opacity" :persistent="true">
            <div v-if="detailsApiCalled" class="loader">
                <v-progress-circular :size="100" :width="8" color="#6FB793" indeterminate></v-progress-circular>
            </div>
            <div v-else class="create-campaign-card scrollbar">
                <div class="scrollable-content">
                    <div class="flex header">
                        <h3 v-if="isEditCampaign">Edit campaign</h3>
                        <h3 v-else>Create a new campaign</h3>
                        <h3 v-if="isEditCampaign">1/2</h3>
                        <h1 v-else></h1>
                    </div>

                    <!-- campaign name  -->
                    <v-text-field
                        v-model="campaignName"
                        :light="true"
                        outlined
                        placeholder="Add your campaign name here"
                        color="#121212"
                        hide-details="true"
                        style="margin-right: 5px"
                    ></v-text-field>

                    <!-- comapany name  -->
                    <div class="flex form-input">
                        <v-autocomplete
                            v-model="companyName"
                            :light="true"
                            :items="businessList"
                            :loading="isLoading"
                            :search-input.sync="search"
                            item-text="name"
                            item-value="id"
                            placeholder="Comapany Name"
                            hide-details="true"
                            :return-object="true"
                            outlined
                            color="#121212"
                            style="width: 100%"
                            class="companyNameBox"
                        >
                            <template v-slot:no-data>
                                <v-list-item>
                                    <v-list-item-title> Search company name </v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                        <!-- camapaign objetive -->
                        <v-select
                            v-model="selectedCampaignObj"
                            :items="campaignObjective"
                            :return-object="true"
                            item-text="display_text"
                            item-value="id"
                            placeholder="Campaign objective"
                            hide-details="true"
                            outlined
                            color="#121212"
                            style="width: 100%"
                            :light="true"
                            :disabled="isEditCampaign"
                        ></v-select>
                    </div>

                    <!-- Money CPA and total budget  -->
                    <div class="flex form-input">
                        <v-text-field
                            v-model="cpaAmount"
                            type="Number"
                            min="0"
                            prefix="₹"
                            :light="true"
                            outlined
                            placeholder="Cost per action (₹) "
                            hide-details="true"
                            color="#121212"
                            style="width: 100%"
                        ></v-text-field>
                        <!-- total budget  -->
                        <v-text-field
                            v-model="totalBudget"
                            type="Number"
                            min="0"
                            prefix="₹"
                            :light="true"
                            outlined
                            placeholder="Total budget"
                            hide-details="true"
                            color="#121212"
                            style="width: 100%"
                        ></v-text-field>
                    </div>

                    <!-- Date fields  -->
                    <div class="flex form-input">
                        <!-- start date picker  -->
                        <div class="flex" style="column-gap: 20px; width: 100%">
                            <v-menu offset-y>
                                <template v-slot:activator="{on, attrs}">
                                    <div style="width: 100%" v-bind="attrs" v-on="on">
                                        <v-text-field
                                            :light="true"
                                            v-model="startDate"
                                            outlined
                                            placeholder="Start Date"
                                            hide-details="true"
                                            readonly
                                            append-icon="mdi-calendar-month-outline"
                                            aria-required="true"
                                            color="#121212"
                                        ></v-text-field>
                                    </div>
                                </template>
                                <v-date-picker @input="onDateRangeChange" color="#328937" v-model="startDate" no-title :show-current="false" width="350px" />
                            </v-menu>
                            <v-text-field :light="true" color="#121212" v-model="startTime" label="Start Time" type="time" outlined hide-details="true"></v-text-field>
                        </div>

                        <!-- end date picker  -->
                        <div class="flex" style="column-gap: 20px; width: 100%">
                            <v-menu offset-y>
                                <template v-slot:activator="{on, attrs}">
                                    <div style="width: 100%" v-bind="attrs" v-on="on">
                                        <v-text-field
                                            :light="true"
                                            v-model="endDate"
                                            outlined
                                            placeholder="End Date"
                                            hide-details="true"
                                            readonly
                                            append-icon="mdi-calendar-month-outline"
                                            aria-required="true"
                                            color="#121212"
                                        ></v-text-field>
                                    </div>
                                </template>
                                <v-date-picker color="#328937" v-model="endDate" no-title :min="startDate" :show-current="false" width="350px" />
                            </v-menu>
                            <v-text-field :light="true" color="#121212" v-model="endTime" label="End Time" type="time" outlined hide-details="true"></v-text-field>
                        </div>
                    </div>

                    <!-- Select language and campaign tag  -->
                    <div class="flex form-input">
                        <v-select
                            v-model="selectedLanguage"
                            :light="true"
                            :items="language"
                            item-text="display_text"
                            item-value="id"
                            placeholder="Select language"
                            hide-details="true"
                            outlined
                            style="width: 100%"
                        ></v-select>
                        <!-- campaign tag  -->
                        <v-select
                            v-model="selectedCampaigntags"
                            :light="true"
                            :items="campaignTags"
                            item-text="tag_text"
                            item-value="id"
                            placeholder="Campaign tag"
                            hide-details="true"
                            outlined
                            style="width: 100%"
                            multiple
                        ></v-select>
                    </div>

                    <!-- Payment -->
                    <div class="flex form-input">
                        <!-- action count and target  -->
                        <div class="flex" style="column-gap: 40px; width: 100%">
                            <v-text-field
                                v-model="actionCount"
                                label="Action Count"
                                type="Number"
                                :light="true"
                                outlined
                                disabled
                                placeholder="Action count"
                                hide-details="true"
                                color="#121212"
                                style="width: 50%"
                            ></v-text-field>
                            <v-select
                                v-model="selectedActionTarget"
                                :items="actionTarget"
                                item-text="display_text"
                                item-value="id"
                                placeholder="Action target"
                                hide-details="true"
                                outlined
                                color="#121212"
                                style="width: 50%"
                                :light="true"
                            ></v-select>
                        </div>
                    </div>

                    <!-- Audience selection  -->
                    <div class="flex select-audience">
                        <h3>Select Audience</h3>
                    </div>
                    <div class="flex form-input" style="width: 100%">
                        <!-- location  -->
                        <div style="width: 100%">
                            <v-select
                                v-model="seletedStates"
                                :items="stateIds"
                                item-text="eng_name"
                                item-value="id"
                                placeholder="State"
                                hide-details="true"
                                outlined
                                color="#121212"
                                :light="true"
                                :return-object="true"
                                multiple
                                small-chips
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item ripple @mousedown.prevent @click="toggle">
                                        <v-list-item-action>
                                            <v-icon :color="seletedStates.length > 0 ? 'green darken-3' : ''">
                                                {{ icon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title> Select All </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:selection="{item, index}">
                                    <v-chip v-if="index === 0">
                                        <span>{{ item.eng_name }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text text-caption"> (+{{ seletedStates.length - 1 }} others) </span>
                                </template>
                            </v-select>
                        </div>

                        <!-- for district  -->
                        <div style="width: 101%">
                            <v-menu style="width: 100%" :close-on-content-click="false">
                                <template v-slot:activator="{on, attrs}">
                                    <div class="district-box" v-bind="attrs" v-on="on">
                                        <p v-if="selectedDistricts.length === 0">Districts</p>
                                        <div v-if="selectedDistricts.length !== 0" class="flex" style="justify-content: flex-start">
                                            <v-chip>
                                                {{ selectedDistricts[0].eng_name }}
                                            </v-chip>
                                            <p v-if="selectedDistricts.length > 1" class="othersmsg">
                                                (+{{ selectedDistricts.length - 1 }}
                                                others)
                                            </p>
                                        </div>
                                        <v-icon>mdi-menu-down</v-icon>
                                    </div>
                                </template>
                                <div v-if="seletedStates.length !== 0" class="district-dropdown">
                                    <template>
                                        <v-expansion-panels :accordion="true">
                                            <v-expansion-panel v-for="(item, ind) in locationObject" :key="ind">
                                                <v-expansion-panel-header>
                                                    <p>{{ item.stateName }}</p>
                                                </v-expansion-panel-header>

                                                <v-expansion-panel-content>
                                                    <v-chip
                                                        v-if="item.isSelectedAll"
                                                        :class="{
                                                            active: item.isSelectedAll,
                                                        }"
                                                        class="selectall-chip"
                                                        color="#1d8d56"
                                                        @click="selectAllDistrict(item, ind)"
                                                    >
                                                        Select All
                                                    </v-chip>

                                                    <v-chip
                                                        :class="{
                                                            active: item.isSelectedAll,
                                                        }"
                                                        v-else
                                                        class="selectall-chip"
                                                        @click="selectAllDistrict(item, ind)"
                                                    >
                                                        Select All
                                                    </v-chip>

                                                    <v-chip-group active-class="primary--text" :column="true" multiple v-model="selectedDistricts">
                                                        <div v-for="(item, i) in item.districts" :key="i">
                                                            <v-chip :value="item" @click="handleDistClick(ind)">
                                                                {{ item.eng_name }}
                                                            </v-chip>
                                                        </div>
                                                    </v-chip-group>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </template>
                                </div>
                            </v-menu>
                        </div>
                    </div>
                    <!-- for crop and topics  -->
                    <div class="flex form-input">
                        <v-autocomplete
                            v-model="selectedCrops"
                            multiple
                            :light="true"
                            :items="croplist"
                            item-value="id"
                            item-text="title"
                            placeholder="Choose crop"
                            hide-details="true"
                            outlined
                            color="#121212"
                            style="width: 100%"
                        >
                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleCrop">
                                    <v-list-item-action>
                                        <v-icon :color="selectedCrops.length > 0 ? 'green darken-3' : ''">
                                            {{ iconcrop }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title> Select All </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{item, index}">
                                <v-chip v-if="index === 0">
                                    <span>{{ item.title }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text text-caption"> (+{{ selectedCrops.length - 1 }} others) </span>
                            </template>
                        </v-autocomplete>

                        <!-- for topics  -->
                        <v-autocomplete
                            v-model="selectedTopics"
                            :persistent-placeholder="true"
                            multiple
                            :light="true"
                            :items="topiclist"
                            item-value="id"
                            item-text="title"
                            placeholder="Choose topic"
                            hide-details="true"
                            outlined
                            color="#121212"
                            style="width: 100%"
                        >
                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleTopic">
                                    <v-list-item-action>
                                        <v-icon :color="selectedTopics.length > 0 ? 'green darken-3' : ''">
                                            {{ icontopic }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title> Select All </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{item, index}">
                                <v-chip v-if="index === 0">
                                    <span>{{ item.title }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text text-caption"> (+{{ selectedTopics.length - 1 }} others) </span>
                            </template>
                        </v-autocomplete>
                    </div>
                </div>

                <!-- button section  -->
                <div class="button-section flex">
                    <v-btn @click="closeAll" elevation="0" class="cancel-btn" color="#EBF5F0"> Cancel </v-btn>
                    <v-btn @click="handleNextClick()" elevation="0" class="next-btn" color="#1D8D56" :disabled="disableNext"> Next </v-btn>
                </div>
            </div>
        </v-dialog>
        <!-- advertisement flow  -->
        <div v-if="createAdOverlay">
            <create-advertisement
                :data="data"
                :createAdOverlay="createAdOverlay"
                :cardSize="cardSize"
                @closeCreateAdOverlay="closeCreateAdOverlay"
                @cancelAdCreation="closeAll"
                @closeAll="reloadApi"
            />
        </div>

        <!-- post id selection flow  -->
        <post-selection :data="data" :postSelectionOverlay="postSelectionOverlay" @closePostSelectionOverlay="closePostSelectionOverlay" @reloadApi="reloadApi" />

        <!-- lead form generation flow  -->
        <!-- <lead-form
            :cardSize="cardSize"
            :data="data"
            ref="createFormRef"
            :dialog="leadFormOverlay"
            @closeLeadFormOverlay="closeLeadFormOverlay"
            @closeAll="closeAll"
            @reloadApi="reloadApi"
        /> -->

        <!-- product selection flow  -->
        <div v-if="productListOverlay">
            <product-list
                :cardSize="cardSize"
                :data="data"
                :productListOverlay="productListOverlay"
                :selectedCompanyID="selectedCompanyID"
                @closeProductListOverlay="closeProductListOverlay"
                @closeAll="closeAll"
                @reloadApi="reloadApi"
            />
        </div>

        <!-- edit post flow  -->
        <edit-posts
            :cardSize="cardSize"
            :data="editedData"
            :postData="postData"
            @closeEditOverlay="closeEditOverlay"
            @closeAll="closeOverlay"
            @reloadApi="reloadApi"
            :editPostOverlay="editPostOverlay"
        />

        <!-- lead form generation flow  open list of available forms-->
        <div v-if="leadFormListOverlay">
            <lead-form-list @closeAll="closeAll" @reloadApi="reloadApi" :cardSize="cardSize" :data="data" :leadFormListOverlay="leadFormListOverlay" @closeLeadFormListOverlay="closeLeadFormListOverlay" :selectedCompanyID="selectedCompanyID" />
        </div>
    </div>
</template>

<script>
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
import moment from "moment";

// components
import createAdvertisement from "./create-advertisement.vue";
import postSelection from "./post-selection.vue";
import productList from "./product-list.vue";
import leadForm from "./lead-form.vue";
import editPosts from "./edit-posts.vue";
import leadFormList from "./form-list.vue";

export default {
    name: "createCampaign",
    components: {
        "create-advertisement": createAdvertisement,
        "post-selection": postSelection,
        "product-list": productList,
        "lead-form": leadForm,
        "edit-posts": editPosts,
        "lead-form-list": leadFormList,
    },
    data() {
        return {
            // form fields
            campaignName: "",
            companyName: "",
            selectedCompanyID: "",
            businessList: [],
            campaignObjective: [],
            selectedCampaignObj: "",
            apiStartDate: "",
            apiEndData: "",
            startDate: "",
            endDate: "",
            paymentAction: [],
            selectedPaymentAction: "impression",
            actionTarget: [],
            selectedActionTarget: "",
            cpaAmount: null,
            totalBudget: null,
            actionCount: null,
            campaignTags: [],
            selectedCampaigntags: [],
            // selectedCampaigntags: ["551259e2-ae52-4168-9936-5631653bb4ae"],
            croplist: [],
            topiclist: [],
            cardSize: [],

            selectedCrops: [],
            selectedTopics: [],
            // selectedTopics: [
            //     "6fbae44e-3845-4a7b-a6a0-3ce5a1b6f30c",
            //     "7f75f803-7185-4770-8884-f6c2ccb0b829",
            // ],
            // selectedCrops: [
            //     "fdf00c93-c890-4b71-933d-56d787accb77",
            //     "866d904b-f92d-44ee-bcc2-2052a2609524",
            // ],

            language: [],
            // selectedLanguage: "92de3d00-30e4-43d8-abf3-a8c07805ddce",
            selectedLanguage: "",

            // for location data
            numberOfDist: "",
            stateIds: [],
            seletedStates: [],
            locationObject: [],
            districts: [],
            selectedDistricts: [],
            selectedDistName: [],
            selectedLocation: [],
            previousLength: 0,

            campaignData: {},
            companyDetails: {},
            postData: {},

            // data for creation flow
            data: {
                language_id: "",
                business_id: "",
                campaign_name: "",
                campaign_objective: "",
                promotion_start_time: "",
                promotion_end_time: "",
                payment_action: "impression",
                campaign_target: "",
                cost_per_action: "",
                total_budget: "",
                target_count: 0,
                campaign_tags: [],
                audience_list: {
                    topics: [],
                    crops: [],
                    location: [],
                },
            },

            // data for edit flow
            editedData: {
                campaign_id: "",
                language_id: "",
                business_id: "",
                campaign_name: "",
                promotion_start_time: "",
                promotion_end_time: "",
                payment_action: "impression",
                campaign_target: "",
                cost_per_action: "",
                total_budget: "",
                target_count: 0,
                campaign_tags: [],
                audience_list: {
                    topics: [],
                    crops: [],
                    location: [],
                },
                paused_post_id_list: [],
            },

            // overlay type
            awarenessOverlay: false,
            createAdOverlay: false,
            createCampaignDialog: this.createCampaignOverlay,
            postSelectionOverlay: false,
            productListOverlay: false,
            leadFormOverlay: false,
            editPostOverlay: false,
            leadFormListOverlay: false,

            // for comapny name autocomplele
            isLoading: false,
            model: null,
            search: null,
            params: "",
            isStatefromEditAPI: false,
            detailsApiCalled: false,
            startTime: "00:00",
            endTime: "12:00",
            api_start_time: "",
        };
    },
    watch: {
        // search company name based on val
        search(val) {
            this.params = `&query_text=${val}&query_param=name`;
            this.getBusinesslist();
        },
        createCampaignOverlay: function () {
            this.createCampaignDialog = this.createCampaignOverlay;
        },

        // generate districts based on districts
        seletedStates: function () {
            if (!this.isStatefromEditAPI && this.seletedStates.length > 0) {
                const index = this.seletedStates.length - 1;
                this.getDistricts(this.seletedStates[index]);
            }
            if (!this.isStatefromEditAPI && this.seletedStates.length === 0) {
                this.selectedDistricts.length = 0; // empty the selected dist
            }

            this.locationObject = this.locationObject.filter((item) => {
                return this.checkLocationPresent(item.stateName);
            });

            if (this.locationObject.length !== 0) this.checkDistricts();
        },

        startTime: function () {
            const start = this.startDate + " " + this.startTime;
        },

        totalBudget: function () {
            this.actionCount = Math.ceil(this.totalBudget / this.cpaAmount);
        },
        cpaAmount: function () {
            this.actionCount = Math.ceil(this.totalBudget / this.cpaAmount);
        },

        selectedDistricts: function () {
            this.locationObject.map((item) => {
                item.dist;
            });
        },
        selectedActionTarget: function () {
            console.log("selectedCampaignObj", this.selectedActionTarget);
        },
    },

    props: {
        opacity: Number,
        createCampaignOverlay: Boolean,
        isEditCampaign: Boolean,
        campaignId: String,
    },

    computed: {
        // handle disable button
        disableNext() {
            if (
                !this.campaignName ||
                !this.companyName ||
                !this.selectedCampaignObj ||
                !this.cpaAmount ||
                !this.totalBudget ||
                !this.startDate ||
                !this.endDate ||
                !this.selectedLanguage ||
                !this.selectedCampaigntags.length ||
                !this.actionCount ||
                !this.selectedActionTarget
            )
                return true;
            else return false;
        },

        // select All in all three state , crop list and topic list
        selectAllStates() {
            return this.seletedStates.length === this.stateIds.length;
        },
        selectSomeStates() {
            return this.seletedStates.length > 0 && !this.selectAllStates;
        },
        icon() {
            if (this.selectAllStates) return "mdi-close-box";
            if (this.selectSomeStates) return "mdi-minus-box";
            return "mdi-checkbox-blank-outline";
        },
        selectAllCrops() {
            return this.selectedCrops.length === this.croplist.length;
        },
        selectSomeCrops() {
            return this.selectedCrops.length > 0 && !this.selectAllCrops;
        },
        iconcrop() {
            if (this.selectAllCrops) return "mdi-close-box";
            if (this.selectSomeCrops) return "mdi-minus-box";
            return "mdi-checkbox-blank-outline";
        },
        selectAllTopics() {
            return this.selectedTopics.length === this.topiclist.length;
        },
        selectSomeTopics() {
            return this.selectedTopics.length > 0 && !this.selectAllTopics;
        },
        icontopic() {
            if (this.selectAllTopics) return "mdi-close-box";
            if (this.selectSomeTopics) return "mdi-minus-box";
            return "mdi-checkbox-blank-outline";
        },
    },

    mounted() {
        console.log("CREATE CAMPAIGN MOUNTED");
        this.getCongfigs();
        this.getStateKey();
        this.getCropList();
        this.getTopicList();

        // if for edit get the campaign details
        if (this.isEditCampaign) {
            this.getCampaignDetails();
        }
    },
    methods: {
        toggle() {
            this.$nextTick(() => {
                if (this.selectAllStates) {
                    this.seletedStates = [];
                    this.locationObject = [];
                    this.selectedDistricts = [];
                } else {
                    this.isStatefromEditAPI = true;
                    this.stateIds.map((states) => {
                        this.seletedStates.push(states);
                        const index = this.seletedStates.length - 1;
                        this.getDistricts(this.seletedStates[index]);
                    });

                    this.seletedStates = [...new Set(this.seletedStates.map((obj) => obj))];

                    this.seletedStates.map((dist) => {
                        this.locationObject = this.locationObject.filter((item) => {
                            return item.stateName !== dist.eng_name;
                        });
                    });
                }
            });
        },

        toggleCrop() {
            this.$nextTick(() => {
                if (this.selectAllCrops) {
                    this.selectedCrops = [];
                } else {
                    this.croplist.map((crop) => {
                        this.selectedCrops.push(crop.id);
                    });

                    this.selectedCrops = [...new Set(this.selectedCrops)];
                }
            });
        },
        toggleTopic() {
            this.$nextTick(() => {
                if (this.selectAllTopics) {
                    this.selectedTopics = [];
                } else {
                    // this.selectedTopics = this.topiclist.slice();
                    this.topiclist.map((topic) => {
                        this.selectedTopics.push(topic.id);
                    });

                    this.selectedTopics = [...new Set(this.selectedTopics)];
                }
            });
        },

        checkLocationPresent(statename) {
            for (var i = 0; i < this.seletedStates.length; i++) {
                if (this.seletedStates[i].eng_name === statename) {
                    return true;
                }
            }
            return false;
        },

        // next step of campaign creation -------------
        handleNextClick() {
            this.generateLocation();
            this.generateEpochTime();

            if (this.isEditCampaign) {
                // data for edit api
                this.editedData.campaign_id = this.campaignId;
                this.editedData.language_id = this.selectedLanguage;
                this.editedData.business_id = this.companyName.id;
                this.editedData.campaign_name = this.campaignName;
                this.editedData.campaign_objective = this.campaignData.campaign_objective;
                this.editedData.payment_action = this.selectedPaymentAction;
                this.editedData.campaign_target = this.selectedActionTarget;
                this.editedData.cost_per_action = parseFloat(this.cpaAmount);
                this.editedData.total_budget = parseFloat(this.totalBudget);
                this.editedData.target_count = parseInt(this.actionCount);
                this.editedData.campaign_tags = this.selectedCampaigntags;
                this.editedData.audience_list.topics = this.selectedTopics;
                this.editedData.audience_list.crops = this.selectedCrops;
                this.editedData.audience_list.location = this.selectedLocation;

                console.log("DATA FOR EDIT API---->", this.editedData);

                this.editPostOverlay = true;
            } else {
                // data for api ---
                this.data.language_id = this.selectedLanguage;
                this.data.business_id = this.companyName.id;
                this.data.campaign_name = this.campaignName;
                this.data.campaign_objective = this.selectedCampaignObj.id;
                this.data.payment_action = this.selectedPaymentAction;
                this.data.campaign_target = this.selectedActionTarget;
                this.data.cost_per_action = parseFloat(this.cpaAmount);
                this.data.total_budget = parseFloat(this.totalBudget);
                this.data.target_count = parseInt(this.actionCount);
                this.data.campaign_tags = this.selectedCampaigntags;
                this.data.audience_list.topics = this.selectedTopics;
                this.data.audience_list.crops = this.selectedCrops;
                this.data.audience_list.location = this.selectedLocation;

                console.log("DATA FOR CREATION API---->", this.data);

                // activate overlay
                const selectedId = this.selectedCampaignObj.id;
                if (
                    selectedId === "app_install" ||
                    selectedId === "click_to_call" ||
                    selectedId === "click_to_whatsapp" ||
                    selectedId === "internal_redirection" ||
                    selectedId === "redirection"
                ) {
                    this.createAdOverlay = true;
                } else if (selectedId === "awareness") {
                    this.postSelectionOverlay = true;
                } else if (selectedId === "product_sale") {
                    this.selectedCompanyID = this.companyName.id;
                    this.productListOverlay = true;
                } else if (selectedId === "lead_generation") {
                    // this.$refs.createFormRef.getFormConfigs();
                    // this.leadFormOverlay = true;
                    this.selectedCompanyID = this.companyName.id;
                    this.leadFormListOverlay = true;
                }
            }
        },
        fillFormData() {
            console.log("CAMPAIGN DATA --->", this.campaignData);
            this.campaignName = this.campaignData.campaign_name;
            this.selectedCampaignObj = this.campaignData.campaign_objective;
            this.apiStartDate = this.campaignData.promotion_start_date;
            console.log("apiStartDate&&&->", this.apiStartDate);

            this.startDate = moment(this.apiStartDate).format("YYYY-MM-DD");
            this.startTime = moment(this.apiStartDate).format("HH:mm");
            console.log("START TIME-->", this.startTime);

            this.apiEndData = this.campaignData.promotion_end_date;
            console.log("apiStartDate&&&->", this.apiEndData);

            this.endDate = moment(this.apiEndData).format("YYYY-MM-DD");
            this.endTime = moment(this.apiEndData).format("HH:mm");
            console.log("END TIME-->", this.endTime);

            this.selectedPaymentAction = this.campaignData.payment_action;
            this.selectedActionTarget = this.campaignData.campaign_target;
            this.cpaAmount = this.campaignData.cost_per_action;
            this.totalBudget = this.campaignData.total_budget;
            this.actionCount = this.campaignData.target_count;
            this.selectedLanguage = this.campaignData.language.id;

            this.campaignData.campaign_tag.map((item) => {
                this.selectedCampaigntags.push(item.id);
            });

            this.campaignData.audience.crops.map((item) => {
                this.selectedCrops.push(item.id);
            });

            this.campaignData.audience.topics.map((item) => {
                this.selectedTopics.push(item.id);
            });

            this.campaignData.audience.locations.map((item) => {
                this.isStatefromEditAPI = true;
                this.stateIds.map((states) => {
                    if (item.id === states.id) {
                        this.seletedStates.push(states);
                        const index = this.seletedStates.length - 1;
                        this.getDistricts(this.seletedStates[index]);
                    }
                });
                // console.log("LOCATION OBJ->", this.locationObject);
                if (item.type === "District") {
                    const tempDistrict = {};
                    tempDistrict.eng_name = item.eng_name;
                    tempDistrict.id = item.id;
                    tempDistrict.name = item.name;
                    tempDistrict.slug = item.slug;
                    this.selectedDistricts.push(tempDistrict);
                }
            });
            console.log("LOCATION OBJ->", this.locationObject);

            this.locationObject.map((loc) => {
                console.log("HEEHFIJEBIVKBIVBW", loc);
                console.log("HEEHFIJEBIVKBIVBW", loc.selectedDistricts);
            });

            // for business details
            const businessDetails = this.campaignData.business_profile;
            this.companyDetails.created_at = businessDetails.created_at;
            this.companyDetails.id = businessDetails.id;
            this.companyDetails.image = businessDetails.image;
            this.companyDetails.is_active = businessDetails.is_active;
            this.companyDetails.modified_at = businessDetails.modified_at;
            this.companyDetails.name = businessDetails.name;
            this.companyDetails.phone_number = businessDetails.phone_number;

            const tempCompanyDetails = [];
            tempCompanyDetails.push(this.companyDetails);
            this.businessList = tempCompanyDetails;
            this.companyName = this.companyDetails;

            this.isStatefromEditAPI = false;
            this.postData = this.campaignData;
        },

        // handle overlays ---------------------
        closeLeadFormListOverlay(){
            this.leadFormListOverlay = false;
        },
        closeProductListOverlay() {
            this.productListOverlay = false;
        },
        closePostSelectionOverlay() {
            if (this.data.awareness_post_id) {
                delete this.data.awareness_post_id;
            }
            this.postSelectionOverlay = false;
        },
        closeCreateAdOverlay() {
            this.createAdOverlay = false;
        },
        closeLeadFormOverlay() {
            this.leadFormOverlay = false;
        },
        closeOverlay() {
            this.$emit("closeCreateCampaignOverlay");
        },
        closeEditOverlay() {
            this.editPostOverlay = false;
        },
        reloadApi() {
            this.$emit("reloadApi");
        },

        // close all overlay and move to view campaign page -------------
        closeAll() {
            if (this.leadFormOverlay) {
                this.leadFormOverlay = false;
            }
            if (this.postSelectionOverlay) {
                this.postSelectionOverlay = false;
            }
            if (this.createAdOverlay) {
                this.createAdOverlay = false;
            }
            if (this.productListOverlay) {
                this.productListOverlay = false;
            }
            if(this.leadFormListOverlay) {
                this.leadFormListOverlay = false;
            }
            this.$emit("closeCreateCampaignOverlay");
        },

        checkDistricts() {
            this.selectedDistricts.map((dist) => {
                let flag = true;
                this.locationObject.map((obj) => {
                    obj.districts.map((objDist) => {
                        if (dist.eng_name === objDist.eng_name) {
                            flag = false;
                        }
                    });
                });
                if (flag) {
                    this.selectedDistricts = this.selectedDistricts.filter((item) => {
                        return item.id !== dist.id;
                    });
                }
            });
        },
        generateEpochTime() {
            const start = this.startDate + " " + this.startTime;
            console.log("epochStartTime -->", this.startDate, this.startTime);
            const epochStartTime = Number(new Date(start));

            if (this.isEditCampaign) {
                this.editedData.promotion_start_time = parseInt(epochStartTime);
            } else {
                this.data.promotion_start_time = parseInt(epochStartTime);
            }

            const end = this.endDate + " " + this.endTime;
            const epochEndTime = Number(new Date(end));

            if (this.isEditCampaign) {
                this.editedData.promotion_end_time = parseInt(epochEndTime);
            } else {
                this.data.promotion_end_time = parseInt(epochEndTime);
            }
        },
        // create object with location type and location name
        generateLocation() {
            console.log("seletedStates-->", this.seletedStates,this.selectedDistricts);
            this.selectedDistricts.map((item) => {
               
                const templocation = {};
                templocation.location_type = "District";
                templocation.location_id = item.id;
                this.selectedLocation.push(templocation);
            });
            this.seletedStates.map((item) => {
                const templocation = {};
                templocation.location_type = "State";
                templocation.location_id = item.id;
                this.selectedLocation.push(templocation);
            });
        },

        // clear end date if start date > end data
        onDateRangeChange() {
            if (new Date(this.endDate) < new Date(this.startDate)) {
                this.endDate = null;
            }
        },
        handleDistClick(ind) {
            console.log("GERHEKJH", this.locationObject[ind]);
            if (this.locationObject[ind].isSelectedAll === true) {
                this.locationObject[ind].isSelectedAll = false;
            }
        },
        selectAllDistrict(item, ind) {
            if (this.locationObject[ind].isSelectedAll) {
                this.locationObject[ind].isSelectedAll = false;
                this.selectedDistricts = this.selectedDistricts.filter((arrdist) => {
                    return !item.districts.includes(arrdist);
                });
            } else {
                this.locationObject[ind].isSelectedAll = true;
                item.districts.map((dist) => {
                    this.selectedDistricts.push(dist);
                });
            }

            this.selectedDistricts = [...new Set(this.selectedDistricts.map((obj) => obj))];
        },

        // api calls ---------------------------------------------
        // get campaign details with id
        getCampaignDetails() {
            this.detailsApiCalled = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("CAMPAIGN DATA-->", response.data.data);
                    this.detailsApiCalled = false;
                    this.campaignData = response.data.data;
                    this.fillFormData();
                }
            };
            const errorHandler = (response) => {
                this.detailsApiCalled = false;
                this.showToast("Something went wrong internally!", "error", 10000);
            };
            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };
            this.requestGET(`${API_URL.getCamapignDetails}?id=${this.campaignId}`, {}, headers, successHandler, errorHandler);
        },

        // get configs of create content form
        getCongfigs() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("CONFIGS FOR CREATE CONTENT FORM-->", response.data);
                    this.campaignObjective = response.data.campaign_objective;
                    this.paymentAction = response.data.payment_action;
                    this.actionTarget = response.data.action_target;
                    this.language = response.data.language;
                    this.campaignTags = response.data.tags;
                    this.cardSize = response.data.card_size;
                }
            };
            const errorHandler = (response) => {
                this.showToast("Something went wrong internally!", "error", 10000);
            };
            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };
            this.requestGET(API_URL.getConfigs, {}, headers, successHandler, errorHandler);
        },

        // get districts based on selected state id
        getDistricts(state) {
            const stateid = state.id;
            const location = {};
            const ind = this.locationObject.length;
            location.stateName = state.eng_name;
            location.isSelectedAll = false;

            const successHandler = (response) => {
                if (response.status === 200) {
                    location.districts = response.data.results;
                    location.index = ind;

                    if (this.isStatefromEditAPI) {
                        this.locationObject.push(location);
                    } else {
                        var flag = true;
                        this.locationObject.map((item) => {
                            if (item.stateName === location.stateName) {
                                flag = false;
                            }
                        });
                        if (flag) {
                            this.locationObject.push(location);
                        }
                    }
                }
            };

            const errorHandler = (response) => {
                this.showToast("Something went wrong internally!", "error", 10000);
            };
            this.requestGET(`${API_URL.getDistricst}?per_page=300&state=${stateid}`, {}, {}, successHandler, errorHandler);
        },

        // get list of topics
        getTopicList() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.topiclist = response.data.results;
                }
            };
            const errorHandler = (response) => {
                this.showToast("Something went wrong internally!", "error", 10000);
            };

            this.requestGET(`${API_URL.getTopics}`, {}, {}, successHandler, errorHandler);
        },

        // get list of crops
        getCropList() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.croplist = response.data;
                }
            };
            const errorHandler = (response) => {
                this.showToast("Something went wrong internally!", "error", 10000);
            };

            this.requestGET(`${API_URL.getCroplist}`, {}, {}, successHandler, errorHandler);
        },

        // get list of states and key
        getStateKey() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.stateIds = response.data.results;
                }
            };
            const errorHandler = (response) => {
                this.showToast("Something went wrong internally!", "error", 10000);
            };
            this.requestGET(`${API_URL.getStatesQuery}`, {}, {}, successHandler, errorHandler);
        },

        // get list of buisness
        getBusinesslist() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.businessList = response.data.data;
                }
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestGET(`${API_URL.getbusinesslist}?page=${1}&is_active=${true}&data_per_page=${10}${this.params}`, {}, headers, successHandler, errorHandler);
        },
    },
};
</script>

<style lang="scss" scoped>
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 650px;
}
.header {
    justify-content: space-between;
    margin-bottom: 15px;
    margin-right: 5px;
}
.create-campaign-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 25px;
    color: #333333;
    // max-height: 700px;
    overflow: hidden;
}
.scrollable-content {
    height: 530px;
    scroll-margin: 10px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.button-section {
    justify-content: space-between;
    margin-top: 15px;
    margin-right: 14px;
    .v-btn {
        width: 47%;
        height: 56px !important;
        text-transform: capitalize !important;
        font-size: 1rem;
    }
}
.cancel-btn {
    color: #1d8d56 !important;
    font-size: 1rem;
}
.next-btn {
    color: #ffffff;
    font-size: 1rem;
}
.form-input {
    column-gap: 40px;
    margin-top: 14px;
    margin-right: 5px;
}

.select-audience {
    justify-content: flex-start;
    column-gap: 10px;
    margin-top: 20px;
}
.district-con {
    width: 320px !important;
}
.district-dropdown {
    // padding: 10px;
    background-color: #ffffff;
    width: 352px !important;
    height: 290px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.DistBox.input {
    max-height: 32px;
    background-color: #e0e0e0;
    border-radius: 16px;
    max-width: 100%;
}
.selectall-chip {
    // color: #1d8d56;
    cursor: pointer;
    font-weight: 600;

    &.active {
        color: #ffffff;
    }
}
// scrollbar design
::-webkit-scrollbar {
    width: 10px;
    border-left: 1px solid rgba(50, 52, 65, 0.1);
    border-right: 1px solid rgba(50, 52, 65, 0.1);
    margin-left: 100px;
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(50, 52, 65, 0.4);
    border: 2px solid transparent;
    background-clip: content-box;
}
::-webkit-scrollbar-track {
    display: none;
    width: 15px;
}
::-webkit-scrollbar-corner {
    display: none;
    height: 0px;
    width: 0px;
}
.district-box {
    border: 1px solid #9e9e9e;
    padding: 0px 12px;
    border-radius: 3px;
    margin-right: 6px;
    color: rgba(0, 0, 0, 0.87);
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
        margin-bottom: 0px;
        color: #9e9e9e;
    }
}
.othersmsg {
    font-size: 12px;
    color: #9e9e9e !important;
    margin-left: 5px;
}
</style>
<style>
.create-campaign-con.v-dialog {
    width: 800px;
    height: 650px;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: none;
}
.create-campaign-con .v-list-item {
    width: 352px !important;
    background-color: red !important;
}
.district-dropdown .v-expansion-panel-content__wrap {
    padding: 0px 10px 10px !important;
}
.district-dropdown .v-expansion-panel-header {
    padding: 10px 15px 0px !important;
    min-height: 50px;
}
.v-application .primary--text {
    color: #1d8d56 !important;
}
</style>

<style>
.v-application .primary--text {
    color: #1d8d56 !important;
}
.create-campaign-card .v-list .v-list-item--active {
    color: #1d8d56 !important;
}
.create-campaign-card .theme--light.v-chip:not(.v-chip--active) {
    background: #1d8d56;
    color: #ffffff;
}
.DistBox.v-input input {
    background-color: #e0e0e0 !important;
    border-radius: 50px;
    min-width: 100px !important;
    max-width: 200px !important;
    padding: 12px;
}
</style>
